export default "__VITE_ASSET__DRarWVgq__"